/* eslint-disable jira/filename-case */
export const PACKAGE_NAME = 'jiraNavigationAppsSidebarNav4GlobalAppShortcuts';
export const TEAM_NAME = 'jira-cosmos';
